import XLSX from 'xlsx';

export const make_cols = refstr => {
	let column= [], C = XLSX.utils.decode_range(refstr).e.c + 1;
	for(var i = 0; i < C; ++i) column[i] = {name:XLSX.utils.encode_col(i), key:i}
	return column;
};